<div class="capsule">
    <span class="label"> {{label}}</span><span class="num"> {{value}}</span>
</div>